import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "bootstrap/dist/css/bootstrap.min.css";
import { LiveSearch } from "../../../../../sharedComponents/LiveSearch";
import { useEffect } from "react";
import { writeFile, utils } from "xlsx";
import Tooltips from "../../../../../client-staff/Components/CommanPages/Tooltips";

export const ClientListTable = ({ pre_data }) => {
    const [tabledata, setTabledata] = useState([]);
    const [iniData, setIniData] = useState([]);
    // const [xcl, setXcl] = useState([]);
    const [arrow, setArrow] = useState(true);

    const [statusFilter, setStatusFilter] = useState("All");

    // const reportPrepare = (requestData, data) => {
    //     // console.log(requestData, "-----data---------", data); return;
    //     // let temparray = [];
    //     // temparray.push(["name", "surname", "email", "mobile", "status"]);
    //     // requestData.forEach((value) => {
    //     //     temparray.push([
    //     //         value.first_name,
    //     //         value.surname,
    //     //         value.myEmail,
    //     //         value.mobile,
    //     //         value.purchase_status,
    //     //     ]);
    //     // });

    //     let temporary = []
    //     temporary.push(["Full Name", "Email", "Mobile", "Status"]);
    //     requestData.forEach((value) => {
    //         temporary.push([
    //             value.myName,
    //             value.Email,
    //             value.mobile,
    //             value.Status,
    //         ]);
    //     });
    //     setXcl(temporary);
    // };

    const handleDownloadClick = (requestData) => {
        let temporary = []
        temporary.push(["Full Name", "Email", "Mobile", "Status"]);
        requestData.forEach((value) => {
            temporary.push([
                value.myName,
                value.Email,
                value.mobile,
                value.Status,
            ]);
        });

        const worksheet = utils.aoa_to_sheet(temporary);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Client List Sheet 1");

        writeFile(workbook, "Customer_export.xlsx");
    };

    const filterData = (data) => {
        if (typeof data !== "string") {
            return []; // or return an empty array or throw an error, based on your requirement
        }
        const fdata = iniData.filter((item) => {
            const myNameLower = item.myName.toLowerCase();
            const statusLower = item.Status.toLowerCase();
            const genderLower = item.Gender.toLowerCase();
            const startDateLower = item.dob.toLowerCase();

            const dataLower = data.toLowerCase();

            const statusMatch = statusLower.startsWith(dataLower);
            const genderMatch = genderLower.startsWith(dataLower);
            const startDateMatch = startDateLower.startsWith(dataLower);

            const myNameMatch = myNameLower.startsWith(dataLower);

            return statusMatch || genderMatch || startDateMatch || myNameMatch;
        });
        return fdata;
    };



    function sortByNameZA(filteredData) {
        return filteredData.slice().sort((a, b) => {
            const nameA = a.myName.toLowerCase();
            const nameB = b.myName.toLowerCase();
            if (nameA > nameB) return -1;
            if (nameA < nameB) return 1;
            return 0;
        });
    }

    function sortByNameAZ(filteredData) {
        return filteredData.slice().sort((a, b) => {
            const nameA = a.myName.toLowerCase();
            const nameB = b.myName.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
    }

    useEffect(() => {
        if (pre_data && pre_data.length > 0) {
            const resp = sortByNameAZ(pre_data)
            setIniData(resp);
            setTabledata(resp);
        }
    }, [pre_data])


    const searchHandler = (e) => {
        const value = e.target.value;
        if (value) {
            const resp = filterData(value);
            setTabledata(resp);
        } else {
            setTabledata(iniData);
        }
    }

    const filterByStatus = (status) => {
        if (status === "All") {
            setTabledata(iniData);
            return;
        }
        const filtered_data = iniData.filter(
            (item) =>
                String(item.Status || "").toLowerCase() ===
                status.toLowerCase()
        );

        setTabledata(filtered_data);
    };


    const shortHandler = (data) => {
        let resp = data;
        setArrow(!arrow);
        if (arrow) {
            resp = sortByNameZA(data);
            setTabledata(resp);
        } else {
            resp = sortByNameAZ(data);
        }
        setTabledata(resp);
    }
    return (
        <>
            <Row className="row">
                <Col className="col-md-7"
                    style={{ display: 'flex', alignItems: "flex-end", }}>
                    <h4><b>Client List</b></h4>
                </Col>
                {/* <Col></Col> */}
                <Col className="col-md-5">
                    <LiveSearch
                        Placeholder={
                            "Search by Name, Status, gender, Date"
                        }
                        onChange={searchHandler}
                        className={"w-100 instructorSearch"}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="downloadPDf">
                        <button
                            className="export_csv"
                            onClick={() => handleDownloadClick(tabledata)}>
                            Export (CSV)
                        </button>
                    </div>
                </Col>
            </Row>
            <Row >
                <Col>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col"
                                    // style={{
                                    //     display: "flex",
                                    //     justifyContent: " space-between"
                                    // }}
                                    style={{
                                        position: "relative",
                                        textAlign: "left",
                                        paddingRight: "30px",
                                    }}
                                    onClick={() => shortHandler(tabledata)}>
                                    Name{
                                        arrow ? <i class='fas fa-arrow-circle-up'
                                            style={{
                                                fontSize: "24px",
                                                position: "absolute",
                                                right: "8px",
                                                // top: "50%",
                                                transform: "translateY(-50%)",
                                            }}
                                        //  style={{ fontSize: "24px" }}
                                        >
                                        </i> : <i class='fas fa-arrow-circle-down'
                                            // style={{ fontSize: "24px" }}
                                            style={{
                                                fontSize: "24px",
                                                position: "absolute",
                                                right: "8px",
                                                // top: "50%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    }
                                </th>
                                <th scope="col">Date of Birth</th>
                                <th scope="col">Email</th>
                                <th scope="col">Mobile</th>
                                <th scope="col">Age</th>
                                <th scope="col">Gender</th>
                                <th scope="col">Start Date</th>
                                {/* <th scope="col">Status</th> */}

                                <th scope="col">
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <select
                                            className="form-select form-select-sm"
                                            style={{ width: "120px", maxHeight: '35px' }}
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                            onClick={(e) => filterByStatus(e.target.value)}
                                        >
                                            <option value="All">All</option>
                                            <option value="Active">Active</option>
                                            <option value="Deactive">Inactive</option>
                                        </select>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <span>Status    <Tooltips info={'**Inactive Status Definition:** A client is marked as Inactive if they do not have any qualifying confirmed service appointments with a future pass start date, successful workshop bookings with a future scheduled date, or an active purchased pass.'} /></span>
                                    </div>

                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {tabledata && tabledata.map((e) => (
                                <tr key={e.id}>
                                    <td>{e.Name}</td>
                                    <td>{e.dob}</td>
                                    <td>{e.Email}</td>
                                    <td>{e.mobile}</td>
                                    <td>{e.Age}</td>
                                    <td>{e.Gender}</td>
                                    <td>{e.Start_Date}</td>
                                    <td>{e.Status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Col>
                {/* <Col> */}
                {/* <BootstrapTable
                        keyField="id"
                        data={tabledata}
                        columns={columns}
                        striped
                        hover
                        wrapperClasses="table-responsive"
                        pagination={paginationFactory()}
                    /> */}
                {/* </Col> */}
                {iniData && iniData.length <= 0 && (
                    <p className="text-center">Please wait, data is loading...</p>
                )}
            </Row >

        </>
    )
}
